<template>
  <b-container flud>
    <b-row class="tsny_border-top question-fill">
      <b-col class="question-padding">
        <b-row class="mb-3">
          <b-col>
            <b-row>
              <b-col
                ><div class="tsny_text">
                  Posted by
                  <span class="font-weight-bold">{{ question.askedBy }}</span>
                </div></b-col
              >
            </b-row>
            <b-row>
              <b-col
                ><div class="tsny_text">{{ askedAtFormatted }}</div></b-col
              >
            </b-row>
          </b-col>
          <b-col>
            <b-row class="text-right">
              <b-col
                ><div class="tsny_text">
                  Posted in <span class="font-weight-bold">{{ courses }}</span>
                </div></b-col
              >
            </b-row>
            <b-row class="text-right">
              <b-col
                ><div class="tsny_text font-weight-bold">
                  {{ question.topic }}
                </div></b-col
              >
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col
            ><h2 class="tsny_header">{{ question.question }}</h2></b-col
          >
        </b-row>
        <b-row>
          <b-col
            ><div class="tsny_text">{{ question.description }}</div></b-col
          >
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";

export default {
  name: "Question",
  props: {
    question: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseNames: StoreConstants.GETTERS.COURSE_NAMES
    }),
    courses() {
      return this.question.courses.join(", ");
    },
    askedAtFormatted() {
      return moment(this.question.askedAt).format("M/D LT");
    }
  }
};
</script>

<style scoped>
.question-fill {
  background-color: #f8f8f8;
}

.question-padding {
  padding: 25px;
}
</style>
